import type { Enum } from './enum.types';

export const AppPromoType = {
  GENERIC: 'GENERIC',
  DRAW: 'DRAW',
} as const;
export type AppPromoType = Enum<typeof AppPromoType>;
